export default __webpack_public_path__ + "static/3-opentrade-8741c7e3609121207510bf4c23891837.jpg";